import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "shards-react";
import styled from "styled-components";
import MenuBar from "shared/components/MenuBar/MenuBar";
import useToken from "shared/hook/useToken";
import baseUrl from "config/baseUrl";
import contentimgset from "shared/assets/img/contentimgset.png";
import {
  ModalCreateContentList,
  ModalDeleteContentList,
} from "views/ContentSetting/components";
import { ToastContainer, toast } from "react-toastify";

const axios = require("axios").default;
const StyledTable = styled.table`
  width: 100%;
  thead {
    height: 60px;
  }
  tbody tr td {
    border-bottom: 1px solid #e5e5e5;
    padding: 20px 0;
  }
`;
const StyledMedia = styled.div`
  display: flex;
  align-items: center;
  color: #000;
  .media-icon {
    padding: 20px;
    svg {
      height: 45px;
    }
  }
  .media-body-title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .media-body-subtitle {
    color: #818181;
  }
  .media-body {
    line-height: 2.5rem;
  }
`;
const ContentList = (props) => {
  const { match } = props;
  const { token } = useToken();
  const [contentSubListData, setContentSubListData] = useState(null);
  const [contentSettingId, setContentSettingId] = useState(match.params.id);
  const [contentSettingName, setContentSettingName] = useState(null);
  const [contentListData, setContentListData] = useState(null);
  const [openModalCreateContentList, setOpenModalCreateContentList] = useState(
    false
  );
  const [openModalDeleteContentList, setOpenModalDeleteContentList] = useState(
    false
  );
  const [contentListEditData, setContentListEditData] = useState(false);

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          contentSettingId: contentSettingId,
          contentSubSettingId: "",
        },
        show: 100,
        page: 1,
        orderBy: "contentSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/contentsublist`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setContentSubListData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [openModalCreateContentList, openModalDeleteContentList]);

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          contentSettingId: contentSettingId,
        },
        show: 100,
        page: 1,
        orderBy: "contentSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/contentlist`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setContentListData(response.data);
          setContentSettingName(response.data.data[0].contentSettingName);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [contentSettingId]);
  const menu = [
    {
      path: "/administratorhome/contentmain",
      title: "จัดการหน้าหลัก",
    },
    {
      path: "/administratorhome/contentmain",
      title: contentSettingName,
    },
  ];
  return (
    <>
      <Container>
        <ToastContainer />
        <MenuBar menu={menu} mode="contentsetting" />
        <Row>
          <Col md="6">
            <h6 className="bold">จัดการส่วนหัวข้อรอง</h6>
          </Col>
          <Col md="6" className="text-right">
            <Button
              className="btn-white"
              onClick={() => {
                setOpenModalCreateContentList(true);
                setContentListEditData(null);
              }}
            >
              + เพิ่มหัวข้อรอง
            </Button>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <StyledTable>
              <thead>
                <tr>
                  <th style={{ minWidth: "80px" }}>ลำดับหัวข้อ</th>
                  <th>{contentSettingName}</th>
                  <th style={{ minWidth: "100px" }}>ตัวชี้วัด</th>
                  <th style={{ minWidth: "210px" }}>เครื่องมือ</th>
                </tr>
              </thead>
              <tbody>
                {contentSubListData != null &&
                contentSubListData.data.length > 0 ? (
                  contentSubListData.data.map((item, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>
                        <StyledMedia className="media">
                          <img
                            style={{ width: "100px" }}
                            className="mr-3"
                            src={
                              item.contentSubSettingPic
                                ? `${baseUrl}/${item.contentSubSettingPic}`
                                : contentimgset
                            }
                            alt="content"
                          />
                          <div className="media-body">
                            <div>
                              <strong>ภาษาไทย: </strong>
                              {item.contentSubSettingName
                                ? item.contentSubSettingName
                                : "-"}
                            </div>
                            <div>
                              <strong>English: </strong>
                              {item.contentSubSettingNameEN
                                ? item.contentSubSettingNameEN
                                : "-"}
                            </div>
                          </div>
                        </StyledMedia>
                      </td>
                      <td>{item.countData} ตัวชี้วัด</td>
                      <td>
                        <Button
                          className="btn-white"
                          style={{ marginRight: "15px" }}
                          onClick={() => {
                            setOpenModalCreateContentList(true);
                            setContentListEditData(item);
                          }}
                        >
                          แก้ไขข้อมูล
                        </Button>
                        <Button
                          className="btn-white"
                          href={`/administratorhome/contentmain/detail/${item.contentSubSettingId}`}
                        >
                          จัดการหัวข้อรอง
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">ไม่มีข้อมูลส่วนหัวข้อรอง</td>
                  </tr>
                )}
              </tbody>
            </StyledTable>
          </Col>
        </Row>
      </Container>
      {openModalCreateContentList && (
        <ModalCreateContentList
          open={openModalCreateContentList}
          toggle={() => setOpenModalCreateContentList(false)}
          contentSettingId={contentSettingId}
          openDelete={() => setOpenModalDeleteContentList(true)}
          data={contentListEditData}
        />
      )}

      {openModalDeleteContentList && (
        <ModalDeleteContentList
          open={ModalDeleteContentList}
          toggle={() => setOpenModalDeleteContentList(false)}
          openEdit={() => setOpenModalCreateContentList(true)}
          data={contentListEditData}
        />
      )}
    </>
  );
};

export default ContentList;
